/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseAiTutorEvaluationResponseData } from './genericApiResponseAiTutorEvaluationResponseData';
import type { GenericApiResponseAiTutorEvaluationResponseMessage } from './genericApiResponseAiTutorEvaluationResponseMessage';
import type { GenericApiResponseAiTutorEvaluationResponsePagination } from './genericApiResponseAiTutorEvaluationResponsePagination';
import type { GenericApiResponseAiTutorEvaluationResponseError } from './genericApiResponseAiTutorEvaluationResponseError';

export interface GenericApiResponseAiTutorEvaluationResponse {
  data?: GenericApiResponseAiTutorEvaluationResponseData;
  message?: GenericApiResponseAiTutorEvaluationResponseMessage;
  pagination?: GenericApiResponseAiTutorEvaluationResponsePagination;
  error?: GenericApiResponseAiTutorEvaluationResponseError;
  statusCode?: number;
}
